export default __webpack_public_path__ + "static/media/goal_press_to_delete.417ea12a.png";